module.exports = __webpack_public_path__ + "img/success7.368bf9de.gif";